import React, { useState, useEffect } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Input,
  Table,
  UncontrolledTooltip,
  Container,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Nav
} from "reactstrap";

import {
  getDocs,
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  setDoc,
  doc,
} from "firebase/firestore";
import { db } from "../../firebase.js"; // Import your Firebase configuration

import { Link } from "react-router-dom"; // Import the Link component for navigation

export default function Tasks() {
  const [tasks, setTasks] = useState();
  const [loading, setLoading] = useState(false);
  const [newTasks, setNewTasks] = useState({
    task_name: "",
    task_description: "",
    task_date: new Date(),
    task_completed: false,
  });

  const [filterOption, setFilterOption] = useState("all"); // Default: show all tasks
  const [filteredTasks, setFilteredTasks] = useState([]);

  const [displayedTasks, setDisplayedTasks] = useState([]); // State to store the displayed tasks
  const [tasksToShow, setTasksToShow] = useState(6); // Number of tasks to initially display

  const [addModal, setAddModal] = useState(false);
  const addToggle = () => setAddModal(!addModal);

  const [updateModal, setUpdateModal] = useState(false);
  const updateToggle = (task) => {
    setUpdateModal(!updateModal);
    setNewTasks(task);
  };

  useEffect(() => {
    fetchTasksData();
  }, []);

  // gets tasks from firebase
  const fetchTasksData = async () => {
    setLoading(true);

    try {
      const tasksCollectionRef = await collection(db, "tasks");
      getDocs(tasksCollectionRef)
        .then((querySnapshot) => {
          const tasksData = querySnapshot.docs.map((doc) => doc.data());
          setTasks(tasksData);
          setDisplayedTasks(tasksData.slice(0, tasksToShow)); // Initialize displayedTasks with the first batch
          console.log(tasksData);
        })
        .catch((error) => {
          console.error(error.message);
        });
    } catch (error) {
      console.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  // adds new task to firebase
  const addTask = async () => {
    if (newTasks.task_name === "") {
      alert("Missing task name");
      return;
    }

    if (newTasks.task_description === "") {
      alert("Missing task description");
      return;
    }

    try {
      const tasksCollectionRef = collection(db, "tasks");
      const docRef = await addDoc(tasksCollectionRef, newTasks);
      const taskId = docRef.id; // Get the auto-generated ID

      // Add the auto-generated task_id to the newTasks object
      const newTaskWithId = { ...newTasks, task_id: taskId };

      await setDoc(doc(db, "tasks", taskId), newTaskWithId);

      // After adding the task, fetch updated tasks data
      fetchTasksData();
    } catch (error) {
      console.error(error.message);
    }

    setAddModal(false);
    setNewTasks({
      task_name: "",
      task_description: "",
      task_date: new Date(),
      task_completed: false,
    });
  };

  // cancel adding new task
  const cancel = async () => {
    setAddModal(false);
    setNewTasks({
      task_name: "",
      task_description: "",
      task_date: new Date(),
      task_completed: false,
    });
  };

  // cancel adding new task
  const updateCancel = async () => {
    setUpdateModal(false);
    setNewTasks({
      task_name: "",
      task_description: "",
      task_date: new Date(),
      task_completed: false,
    });
  };

  // update a task
  const updateTask = async () => {
    try {
      const taskDocRef = doc(db, "tasks", newTasks.task_id);
      const updatedTask = { ...newTasks }; // Clone the current task data
      delete updatedTask.task_id; // Remove the task_id key, as we don't want to update it

      await updateDoc(taskDocRef, updatedTask);
      // After updating the task, fetch updated tasks data
      fetchTasksData();
    } catch (error) {
      console.error(error.message);
    }

    setUpdateModal(false);
    setNewTasks({
      task_name: "",
      task_description: "",
      task_date: new Date(),
      task_completed: false,
    });
  };

  // delete a task
  const deleteTask = async (taskId) => {
    console.log(taskId);
    const confirmDelete = window.confirm('Are you sure you want to delete this task?');

    if(confirmDelete){
      try {
        const taskDocRef = doc(db, "tasks", taskId);
        await deleteDoc(taskDocRef);
        // After deleting the task, fetch updated tasks data
        fetchTasksData();
      } catch (error) {
        console.error(error.message);
      }
    }
  };


  const filterTasksByDate = (taskDate) => {
    const currentDate = new Date();
    const startOfDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate()
    );
    const endOfDay = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate() + 1
    );

    const startOfWeek = new Date(currentDate);
    startOfWeek.setDate(currentDate.getDate() - currentDate.getDay());
    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 7);

    const startOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );
    const endOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0
    );

    switch (filterOption) {
      case "day":
        return taskDate >= startOfDay && taskDate < endOfDay;
      case "week":
        return taskDate >= startOfWeek && taskDate < endOfWeek;
      case "month":
        return taskDate >= startOfMonth && taskDate <= endOfMonth;
      case "all":
      default:
        return true;
    }
  };

  const filterTasks = () => {
    return tasks.filter((task) => {
      const taskDate = task.task_date.toDate();
      return filterTasksByDate(taskDate);
    });
  };

  useEffect(() => {
    if (tasks) {
      const filtered = filterTasks();
      setFilteredTasks(filtered);
    }
  }, [tasks, filterOption]);

  const handleFilter = (filter) => {
    setFilterOption(filter);
  };

  // when component is loading
  if (loading) {
    return (
      <div className="content">
        <Container>
          <p>Loading...please wait.</p>
        </Container>
      </div>
    );
  }

  // when component has error
  if (!loading && !tasks) {
    return (
      <div className="content">
        <Container>
          <p>There's been an error. Please try refreshing the page.</p>
        </Container>
      </div>
    );
  }

  // when component has no data
  if (!loading && tasks.length === 0) {
    return (
      <>
            <Card>
              <CardHeader>
                <h6 className="title d-inline" style={{fontWeight: 'bold'}}>Tasks ({tasks.length})</h6>
                <p style={{cursor: 'pointer', float: 'right', textDecoration: 'underline'}} onClick={addToggle}>Add Task</p>
              </CardHeader>
              <CardBody>
                <p>You have no current tasks.</p>
              </CardBody>
            </Card>

        {/* modal code for adding */}
        <Modal isOpen={addModal} toggle={addToggle}>
          <ModalHeader toggle={addToggle}>Add New Task</ModalHeader>
          <ModalBody>
            <Form>
              <FormGroup>
                <Label for="taskName">Task Name</Label>
                <Input
                  required
                  style={{color: 'black'}}
                  id="taskName"
                  name="task_name"
                  value={newTasks.task_name}
                  placeholder="Name your task"
                  type="text"
                  onChange={(e) =>
                    setNewTasks((prevTasks) => ({
                      ...prevTasks,
                      task_name: e.target.value,
                    }))
                  }
                />
              </FormGroup>
              <FormGroup>
                <Label for="taskDescription">Task Description</Label>
                <Input
                  required
                  style={{ color: "black", height: "10rem", maxHeight: "12rem" }}
                  id="taskDescription"
                  name="task_name"
                  value={newTasks.task_description}
                  placeholder="Describe your task"
                  maxLength={200} // Limit the input to 200 characters
                  type="textarea"
                  onChange={(e) =>
                    setNewTasks((prevTasks) => ({
                      ...prevTasks,
                      task_description: e.target.value.slice(0, 200),
                    }))
                  }
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={cancel}>
              Cancel
            </Button>
            {" "}
            <Button color="primary" onClick={addTask}>
              Save
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }

  return (
    <>
      <Card className="card-tasks" style={{height: 'auto', maxHeight: '400px'}}>
        <CardHeader>
          <h6 className="title d-inline" style={{fontWeight: 'bold'}}>My Tasks ({tasks.length})</h6>
          <p style={{cursor: 'pointer', float: 'right', textDecoration: 'underline'}} onClick={addToggle}>Add Task</p>

          {/* Filter Links */}
          <Nav style={{ marginBottom: "20px" }}>
              <p
                color="info"
                className="m-1"
                style={{ cursor: "pointer" }}
                onClick={() => handleFilter("all")}
                active={filterOption === "all"}
              >
                All
              </p>
              <p
                color="info"
                className="m-1"
                style={{ cursor: "pointer" }}
                onClick={() => handleFilter("day")}
                active={filterOption === "day"}
              >
                Day
              </p>
              <p
                color="info"
                className="m-1"
                style={{ cursor: "pointer" }}
                onClick={() => handleFilter("week")}
                active={filterOption === "week"}
              >
                Week
              </p>
              <p
                color="info"
                className="m-1"
                style={{ cursor: "pointer" }}
                onClick={() => handleFilter("month")}
                active={filterOption === "month"}
              >
                Month
              </p>
            </Nav>
        </CardHeader>
        <CardBody style={{overflowY: 'hidden'}}>
          <div className="table-full-width table-responsive">
            <Table responsive>
              <tbody>
                {filteredTasks.map((task) => (
                  <tr key={task.task_id}> 
                    <td>
                      <p className="title">{task.task_name}</p>
                      <p className="text-muted">{task.task_description}</p>
                      <p className="text-muted">
                        {task.task_date.toDate().toLocaleDateString()}
                      </p>
                    </td>
                    <td className="td-actions text-right">
                      <Button
                        color="link"
                        id={`tooltipUpdate${task.task_id}`}
                        title=""
                        type="button"
                        onClick={() => updateToggle(task)}
                      >
                        <i className="tim-icons icon-pencil" />
                      </Button>
                      <UncontrolledTooltip
                        delay={0}
                        target={`tooltipUpdate${task.task_id}`}
                        placement="right"
                      >
                        Edit
                      </UncontrolledTooltip>

                      <Button
                        color="link"
                        id={`tooltipDelete${task.task_id}`}
                        title=""
                        type="button"
                        onClick={() => deleteTask(task.task_id)}
                      >
                        <i className="tim-icons icon-trash-simple" style={{color: 'red'}} />
                      </Button>
                      <UncontrolledTooltip
                        delay={0}
                        target={`tooltipDelete${task.task_id}`}
                        placement="right"
                      >
                        Delete
                      </UncontrolledTooltip>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      {/* modal code for adding */}
      <Modal isOpen={addModal} toggle={addToggle}>
        <ModalHeader toggle={addToggle}>Add New Task</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="taskName">Task Name</Label>
              <Input
                required
                style={{ color: "black" }}
                id="taskName"
                name="task_name"
                value={newTasks.task_name}
                placeholder="Name your task"
                type="text"
                onChange={(e) =>
                  setNewTasks((prevTasks) => ({
                    ...prevTasks,
                    task_name: e.target.value,
                  }))
                }
              />
            </FormGroup>
            <FormGroup>
              <Label for="taskDescription">Task Description</Label>
              <Input
                required
                style={{ color: "black", height: "10rem", maxHeight: "12rem" }}
                id="taskDescription"
                name="task_name"
                value={newTasks.task_description}
                placeholder="Describe your task (max 200 characters)"
                type="textarea"
                maxLength={200} // Limit the input to 200 characters
                onChange={(e) =>
                  setNewTasks((prevTasks) => ({
                    ...prevTasks,
                    task_description: e.target.value.slice(0, 200), // Ensure the input does not exceed 200 characters
                  }))
                }
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={cancel}>
            Cancel
          </Button>{" "}
          <Button color="primary" onClick={addTask}>
            Save
          </Button>
        </ModalFooter>
      </Modal>

      {/* modal code for updating */}
      <Modal isOpen={updateModal} toggle={updateToggle}>
        <ModalHeader toggle={updateToggle}>Update Task</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="taskName">Task Name</Label>
              <Input
                style={{ color: "black" }}
                id="taskName"
                name="task_name"
                value={newTasks.task_name}
                placeholder="Name your task"
                maxLength={200} // Limit the input to 200 characters
                type="text"
                onChange={(e) =>
                  setNewTasks((prevTasks) => ({
                    ...prevTasks,
                    task_name: e.target.value.slice(0, 200),
                  }))
                }
              />
            </FormGroup>
            <FormGroup>
              <Label for="taskDescription">Task Description</Label>
              <Input
                style={{ color: "black", height: "10rem", maxHeight: "12rem" }}
                id="taskDescription"
                name="task_name"
                value={newTasks.task_description}
                placeholder="Describe your task"
                type="textarea"
                onChange={(e) =>
                  setNewTasks((prevTasks) => ({
                    ...prevTasks,
                    task_description: e.target.value,
                  }))
                }
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={updateCancel}>
            Cancel
          </Button>{" "}
          <Button color="primary" onClick={updateTask}>
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
